export function prepareLinks(approvalLinks) {
  return approvalLinks.filter((approvalLink) => approvalLink !== "");
}